export default "__VITE_ASSET__9pGSiMMK__"